import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getLangFromPathname } from "@/i18n";

/**
 * Scrolls to top on route change EXCEPT when only the language segment changes
 * (i.e. user clicked the language switcher). Anchor navigation (#hash) is
 * respected: we let the browser handle it and do not force scroll to top.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prev = useRef({ pathname, lang: getLangFromPathname(pathname) });

  useEffect(() => {
    const currentLang = getLangFromPathname(pathname);
    const stripLang = (p) => {
      const parts = (p || "/").split("/").filter(Boolean);
      if (parts[0] === "ar" || parts[0] === "en") parts.shift();
      return "/" + parts.join("/");
    };
    const prevPathNoLang = stripLang(prev.current.pathname);
    const nextPathNoLang = stripLang(pathname);
    const languageOnlyChange =
      currentLang !== prev.current.lang && prevPathNoLang === nextPathNoLang;

    if (!hash && !languageOnlyChange) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
    prev.current = { pathname, lang: currentLang };
  }, [pathname, hash]);

  return null;
}
